function ControllMenu() {
    function init() {
        calculePositionInDesk();
        activeSectionMobile();
    }
    function calculePositionInDesk() {
        jQuery('.menu-header__menu__list__item').on('mouseover', function () {
            const item = jQuery(this);
            const content = jQuery(item.find('.menu-header__menu__list__item__content')[0]);
            const widthContent = content.width();
            const positionItem = item.position();
            const widthItem = item.width();
            const positionMid = positionItem.left + widthItem/2 - widthContent/2;
            //const positionMid = positionItem.left - width/2;
            const left = Math.max(0, positionMid);
            console.log('positionItem', positionItem.left);
            console.log('widthItem', widthItem);
            console.log('widthContent', widthContent);
            console.log('positionMid', positionMid);
            content.css({
                left: positionMid,
                
            })
        });
    }
    function activeSectionMobile() {
        jQuery('.menu-header__menu-mobile__list__item__link').on('click', function () {

            
            const data = jQuery(this).data('data');
            if(!data.childs) {
                return;
            }
            jQuery('.menu-header__menu-mobile__childs__header__title').html(data.title);
            const width = jQuery(window).width();
            jQuery('#menuMobile').animate(
                {
                    scrollLeft: width
                }
            );
            const list = jQuery("<ul class='menu-header__menu-mobile__childs__content__list'>");
            data.childs.forEach(item => {
                const {title, url} = item;
                const li = jQuery("<li class='menu-header__menu-mobile__childs__content__list__item'>");
                const tagLink = jQuery("<a class='menu-header__menu-mobile__childs__content__list__item__link'>");
                li.append(tagLink);
                tagLink.html(title);
                tagLink.attr({
                    href: url
                });
                list.append(li);
            });
            const idContent =`#contentHTML${data.ID}`;
            jQuery('.menu-header__menu-mobile__childs__html').show();
            jQuery('.menu-header__menu-mobile__childs__html__item').hide();
            jQuery(idContent).show();
            jQuery('#contentChildMObile').html(list);
        });
        jQuery('#backMenuMobile').on('click', function() {
            jQuery('#contentChildMObile').html("");
            jQuery('.menu-header__menu-mobile__childs__html').hide();
            jQuery('#menuMobile').animate(
                {
                    scrollLeft: 0
                }
            );
        });

        jQuery('#btnShowMenu').on('click', function() {
            const menu = jQuery('#menuMobile');
            const btnShowMenu = jQuery('#btnShowMenu');
            const classActive = 'menu-header__options--active';
            if(menu.hasClass('d-flex')) {
                menu.removeClass('d-flex');
                btnShowMenu.removeClass(classActive);
            } else {
                menu.addClass('d-flex');
                btnShowMenu.addClass(classActive);
            }
            
        })
    }
    init();
}
new ControllMenu();